import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative p-2 space-y-2" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "break-words" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "break-words" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "break-words" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageInteract = _resolveComponent("MessageInteract")!
  const _component_MessageHour = _resolveComponent("MessageHour")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full rounded-md flex flex-wrap group", _ctx.state.position === 'sent' ? 'ml-[20%] justify-end' : 'mr-[20%] justify-start'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["inline-block rounded-md text-sm text-neutral-600", _ctx.backgroundColor]),
      onMouseenter: _cache[0] || (_cache[0] = () => _ctx.onFocus = true),
      onMouseleave: _cache[1] || (_cache[1] = () => _ctx.onFocus = false)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          id: _ctx.state.uuid
        }, [
          _createElementVNode("b", _hoisted_3, _toDisplayString(_ctx.state.title), 1),
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.state.content), 1),
          _createElementVNode("ul", {
            class: _normalizeClass(["flex justify-between mt-1", [
                            { 'space-x-1' : _ctx.buttonCount === 1 },
                            { 'py-1 space-x-1': _ctx.buttonCount === 2 },
                            { 'flex-col py-1 space-y-1' : _ctx.buttonCount > 2 }
                        ]])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.buttons, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: _normalizeClass([
                                'cursor-pointer w-full p-1.5 text-center rounded-md text-xs',
                                'bg-neutral-300 bg-opacity-50 webchat-transition hover:bg-opacity-100',
                            ]),
                onClick: () => _ctx.emit('onClick',  item)
              }, _toDisplayString(item), 11, _hoisted_6))
            }), 128))
          ], 2),
          _createElementVNode("small", _hoisted_7, _toDisplayString(_ctx.state.footer), 1),
          _createVNode(_component_MessageInteract, {
            value: _ctx.state.uuid,
            focus: _ctx.onFocus,
            onOnUpdate: _ctx.handleClickInteract
          }, null, 8, ["value", "focus", "onOnUpdate"])
        ], 8, _hoisted_2)
      ])
    ], 34),
    _createVNode(_component_MessageHour, {
      date: _ctx.state.date
    }, null, 8, ["date"])
  ], 2))
}